import { animate, stagger, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { XMenuItem } from './x-menu-item.model';

@Component({
  selector: 'app-panel-menu',
  templateUrl: './panel-menu.component.html',
  styleUrls: ['./panel-menu.component.scss']
})
export class PanelMenuComponent implements OnInit {

  @Input() menuItens: XMenuItem[];
  @Output() command: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  expand(itemIndex: number, subItemIndex?: number) {
    this.menuItens.forEach((item: XMenuItem, index: number) =>
      (subItemIndex === undefined || subItemIndex !== undefined) && index !== itemIndex && item.expanded ? item.expanded = false : undefined
        || item.active ? item.active = false : undefined
      || item.items && item.items.length > 0 && item.items.map(sub => sub.active ? sub.active = false : undefined));

    if (subItemIndex !== undefined) {
      this.menuItens[itemIndex].items![subItemIndex].active = !this.menuItens[itemIndex].items![subItemIndex].active;
      this.command.emit({ active: this.menuItens[itemIndex].items![subItemIndex].active, id: this.menuItens[itemIndex].items![subItemIndex].id });
    } else {
      if (this.menuItens[itemIndex].items && this.menuItens[itemIndex].items!.length > 0) {
        this.menuItens[itemIndex].expanded = !this.menuItens[itemIndex].expanded;
      } else {
        this.menuItens[itemIndex].active = !this.menuItens[itemIndex].active;
        this.command.emit({ active: this.menuItens[itemIndex].active, id: this.menuItens[itemIndex].id });
      }
    }
  }

}
